<template>
  <div class="tab-card">
    <el-collapse v-model="activeName">
      <el-collapse-item title name="0">
        <template slot="title">
          <img class="title-icon" src="@/assets/imgs/course.png" />
          <span class="title-text">订阅课程</span>
        </template>
        <router-link
          class="menu-item"
          v-report="'1003.2449.3001.7930'"
          :class="$route.name == 'video' ? 'menu-click' : ''"
          to="/center/video"
        >视频课</router-link>
        <router-link
          class="menu-item"
          v-report="'1003.2449.3001.7931'"
          :class="$route.name == 'live' ? 'menu-click' : ''"
          to="/center/live"
        >直播·训练营</router-link>
        <router-link
          class="menu-item"
          v-report="'1003.2449.3001.7932'"
          :class="$route.name == 'special' ? 'menu-click' : ''"
          to="/center/special"
        >特训班</router-link>
        <router-link
          class="menu-item"
          :class="$route.name == 'geek' ? 'menu-click' : ''"
          to="/center/geek"
        >极客时间</router-link>
      </el-collapse-item>
      <el-collapse-item title name="1">
        <template slot="title">
          <img class="title-icon" src="@/assets/imgs/resource.png" />
          <span class="title-text">我的资源</span>
        </template>
        <router-link
          class="menu-item"
          v-report="'1003.2449.3001.7927'"
          :class="$route.name == 'download' ? 'menu-click' : ''"
          to="/center/download"
        >已下载资源</router-link>
        <router-link
          class="menu-item"
          v-report="'1003.2449.3001.7928'"
          :class="$route.name == 'collect' ? 'menu-click' : ''"
          to="/center/collect"
        >已收藏资源</router-link>
      </el-collapse-item>
      <el-collapse-item title name="2">
        <template slot="title">
          <img class="title-icon" src="@/assets/imgs/column.png" />
          <span class="title-text">订阅专栏</span>
        </template>
        <!-- <router-link
          class="menu-item"
          v-report="'1003.2449.3001.7933'"
          :class="$route.name == 'marrow' ? 'menu-click' : ''"
          to="/center/gitchat"
        >精品专栏</router-link> -->
        <router-link
          class="menu-item"
          v-report="'1003.2449.3001.7934'"
          :class="$route.name == 'pictext' ? 'menu-click' : ''"
          to="/center/blog"
        >图文专栏</router-link>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: [],
    };
  },
  mounted() {
    this.activeName = ["0", "1", "2", "3"];
  },
  methods: {
    routerPush(path) {
      if (this.$route.path != path) {
        this.$router.push({ path: path });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tab-card {
  padding: 16px;
  padding-bottom: 8px;
  background: #fff;
  border-radius: 2px;

  .title-icon {
    margin-left: 13px;
    margin-right: 5px;
    width: 12px;
    height: 12px;
    object-fit: cover;
  }

  .title-text {
    font-size: 12px;
    font-weight: 400;
    color: #222226;
    line-height: 36px;
    user-select: none;
  }

  .menu-item {
    display: block;
    text-decoration: none;
    padding-left: 28px;
    padding-right: 10px;
    margin-bottom: 8px;
    border-radius: 18px;
    font-size: 12px;
    font-weight: 400;
    color: #555666;
    line-height: 36px;
    user-select: none;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .menu-item:hover {
    background: #f5f6f7;
  }

  .menu-click {
    background: #ededed !important;
  }
}
</style>

<style>
.tab-card .el-collapse {
  border: 0;
}

.tab-card .el-collapse-item__header {
  margin-bottom: 8px;
  border-radius: 2px;
  height: 36px;
  background: #f5f6f7;
  border: 0;
}

.tab-card .el-collapse-item__wrap {
  border: 0;
}

.tab-card .el-collapse-item__content {
  padding: 0px;
  padding-bottom: 8px;
}

.tab-card .el-collapse-item__arrow {
  transform: rotate(-90deg);
}
</style>
